module.exports = __webpack_public_path__ + "img/galery11.515df641.jpg";